import { Action, createReducer, on } from '@ngrx/store';
import { IEmployeeParams, IPreviousSelfieResponse } from '../models/selfie.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadPreviousSelfieRequest, loadPreviousSelfieResponse, loadPreviousSelfieFailure } from '../actions/selfie.actions';

export const previousSelfieFeatureKey = 'previousSelfie';

export interface PreviousSelfieState {
  previousSelfieRequest: string;
  previousSelfieResponse: IPreviousSelfieResponse[];
  previousSelfieFailure: IGenericError<ErrorResponse>;
}

export const initialState: PreviousSelfieState = {
  previousSelfieRequest: undefined,
  previousSelfieResponse: undefined,
  previousSelfieFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadPreviousSelfieRequest, (state, action) => ({
    ...state,
    previousSelfieRequest: action.request
  })),
  on(loadPreviousSelfieResponse, (state, action) => ({
    ...state,
    previousSelfieResponse: action.response
  })),
  on(loadPreviousSelfieFailure, (state, action) => ({
    ...state,
    previousSelfieFailure: action.error
  }))
);

export const getPreviousSelfieRequest = (state: PreviousSelfieState) => state.previousSelfieRequest;
export const getPreviousSelfieResponse = (state: PreviousSelfieState) => {
  return state.previousSelfieResponse;
};
export const getPreviousSelfieFailure = (state: PreviousSelfieState) => state.previousSelfieFailure;
